(function() {
  define('bazemont/news/post',['angular'], function() {
    'use strict';
    return angular.module('bazemontNewsPost', []).component('bazemontNewsPost', {
      templateUrl: '/assets/javascripts/bazemont/news/post.html',
      bindings: {
        postId: '@'
      },
      controller: [
        '$http', '$scope', 'NewsPost', 'TlhNotifierService', 'TlhCmsEvents', 'TlhNotificationService', function($http, $scope, NewsPost, TlhNotifierService, TlhCmsEvents, TlhNotificationService) {
          var cancelPostModifications, edited, handlePostChange, initialValue, preselectPostCategory, savePostModifications, vm;
          vm = this;
          edited = false;
          initialValue = null;
          vm.$onInit = function() {
            return NewsPost.get({
              id: vm.postId
            }, function(result) {
              vm.post = result;
              initialValue = angular.copy(vm.post);
              return $http.get('/api/user-categories', {
                cache: true
              }).then(function(response) {
                vm.categories = response.data.categories;
                vm.isAdmin = response.data.isAdmin;
                return preselectPostCategory();
              });
            });
          };
          vm.isFuture = function(date) {
            var now;
            now = new Date();
            return date > now;
          };
          preselectPostCategory = function() {
            var category, _i, _len, _ref, _results;
            if (vm.categories.length > 1) {
              if (vm.post && vm.post.category) {
                _ref = vm.categories;
                _results = [];
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                  category = _ref[_i];
                  if (category.id === vm.post.category.id) {
                    vm.post.category = category;
                    break;
                  } else {
                    _results.push(void 0);
                  }
                }
                return _results;
              }
            }
          };
          savePostModifications = function() {
            TlhNotificationService.info({
              message: 'Enregistrement en cours...',
              delay: false
            });
            return new NewsPost(vm.post).$save().then(function(response) {
              if (response.success) {
                initialValue = angular.copy(response.post);
                vm.post = angular.copy(initialValue);
                preselectPostCategory();
                TlhNotifierService.send(TlhCmsEvents.SAVE_SUCCESS);
                return TlhNotificationService.success({
                  message: 'Enregistrement terminé',
                  replaceMessage: true
                });
              }
            })["catch"](function(error) {
              var message;
              message = "L'enregistrement a échoué :<br>";
              message += error.data ? error.data : "Erreur inattendue, veuillez contacter l'administrateur.";
              TlhNotifierService.send(TlhCmsEvents.SAVE_FAILED);
              TlhNotificationService.error({
                message: message,
                replaceMessage: true,
                delay: false
              });
              return console.error(error);
            });
          };
          cancelPostModifications = function() {
            return vm.post = angular.copy(initialValue);
          };
          handlePostChange = function(newValue, oldValue) {
            if (newValue !== oldValue) {
              if (!edited && !angular.equals(newValue, initialValue)) {
                TlhNotifierService.send(TlhCmsEvents.PAGE_MODIFIED);
                edited = true;
              }
              if (edited && angular.equals(newValue, initialValue)) {
                TlhNotifierService.send(TlhCmsEvents.PAGE_UNMODIFIED);
                return edited = false;
              }
            }
          };
          $scope.$on(TlhCmsEvents.SAVE_ALL, savePostModifications);
          $scope.$on(TlhCmsEvents.CANCEL_ALL, cancelPostModifications);
          $scope.$watch(function() {
            return vm.post;
          }, handlePostChange, true);
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=post.js.map
;
